module.exports = __webpack_public_path__ + "static/img/3.志工服務活動2025.c767c4c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/csr/charitable-activities/3.志工服務活動2025.jpg
// module id = 3jTJ
// module chunks = 99